import H4Text from './H4Text';

export default H4Text;
